import Entities from './Entities';

export default Entities;
